module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subjects text-dark",
    class: {
      'subjects--is-activities': _vm.isActivities
    }
  }, [(_vm.noActiveSchoolYears) ? _c('Banner') : _vm._e(), _vm._v(" "), (!_vm.isActivities) ? _c('div', {
    staticClass: "subjects-header"
  }, [_c('div', {
    staticClass: "subjects-header__left"
  }, [_c('h1', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['headline']))]), _vm._v(" "), _c('ChangeSchoolYear', {
    attrs: {
      "whiteTheme": true
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['subjects'],
      "tags": _vm.subjectTypeFilters,
      "selectedTags": _vm.selectedSubjectTypeFilters
    },
    on: {
      "select": _vm.toggleSelectedSubjectTypeFilters,
      "clear": _vm.clearSelectedSubjectTypeFilters
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['grades'],
      "tags": _vm.klassTags,
      "selectedTags": _vm.selectedKlassFilters
    },
    on: {
      "select": _vm.toggleKlassTag,
      "clear": _vm.clearSelectedKlassFilters
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "subjects-header__right"
  }, [(!_vm.isLoading && _vm.klassesWithoutSubjects.length > 0 && _vm.schoolIsFromDK) ? _c('button', {
    staticClass: "do-bttn do-bttn--large",
    on: {
      "click": _vm.setImportSubjects
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['import_subjects']) + "\n      ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "color": "blue"
    }
  }) : [(_vm.klassIds.length < 1) ? _c('div', [_c('h2', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_classes_first']))])]) : _c('div', {
    staticClass: "subjects-table",
    style: ({
      'width': _vm.tableWidth
    })
  }, [_c('table', {
    staticClass: "d-table"
  }, [_c('thead', {
    ref: "tableHead"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "min-width": "160px"
    }
  }), _vm._v(" "), _vm._l((_vm.klassHeaderColumns), function(cal) {
    return _c('th', {
      key: cal.id
    }, [_c('div', {
      staticClass: "column-name"
    }, [_vm._v(_vm._s(cal.vName))]), _vm._v(" "), _c('div', {
      staticClass: "column-hours"
    }, [_vm._v(_vm._s(cal.vTotalHours))])])
  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.filteredKlassIds), function(calId) {
    return _c('td', {
      key: calId,
      staticClass: "td-create-bttn-container"
    }, [_c('button', {
      staticClass: "do-bttn td-bttn--small",
      on: {
        "click": function($event) {
          return _vm.setCreateInCalendarId(calId)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale]['create']) + "\n              ")])])
  })], 2), _vm._v(" "), (!_vm.isActivities) ? _c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.filteredKlassIds), function(calId) {
    return _c('td', {
      key: calId,
      staticClass: "td-create-bttn-container"
    }, [_c('button', {
      staticClass: "do-bttn td-bttn--small",
      on: {
        "click": function($event) {
          return _vm.openKlassRoomModal(calId)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale]['edit']) + "\n              ")])])
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.visibleSubjectsTable), function(row) {
    return _c('tr', {
      key: row.id
    }, [_c('th', [_c('div', {
      staticClass: "th-wrench-icon-container"
    }, [_vm._v("\n              " + _vm._s(row.name) + "\n              "), _c('span', {
      staticClass: "icon__bg-circle icon__bg-circle--small th-wrench-icon icon-wrench",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openBulkColorModal(row)
        }
      }
    })])]), _vm._v(" "), _vm._l((row.cells), function(cell) {
      return [(cell.hasSubject) ? _c('td', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            arrow: true,
            onShow: function () { return !!cell.v_tooltip; }
          }),
          expression: "{\n                  arrow: true,\n                  onShow: () => !!cell.v_tooltip\n                }"
        }],
        key: cell.calId,
        staticClass: "td__subject",
        class: [{
            'td__subject--has-user': cell.v_subjectHasTeachers
          },
          {
            'td__subject--has-room': cell.v_subjectHasRooms
          },
          {
            'td__subject-has-other-klass': cell.v_subjectOtherKlasses && cell.v_subjectOtherKlasses.length > 0
          }
        ],
        style: ({
          '--subjectBgColor': cell.klass.color
        }),
        attrs: {
          "aria-hours": cell.vHours,
          "content": cell.v_tooltip
        },
        on: {
          "click": function($event) {
            return _vm.setEditSubject(cell.klass)
          }
        }
      }) : _c('td', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            animateFill: false,
            animation: 'shift-away',
            zIndex: '999999992',
            boundary: 'window'
          }),
          expression: "{\n                  animateFill: false,\n                  animation : 'shift-away',\n                  zIndex: '999999992',\n                  boundary: 'window'\n                }"
        }],
        key: cell.calId,
        staticClass: "td__create-subject",
        attrs: {
          "content": cell.createTooltip
        },
        on: {
          "click": function($event) {
            if ($event.target !== $event.currentTarget) { return null; }
            return _vm.setIsCreateSubject(row.rawSubject, cell.klass)
          }
        }
      }, [(_vm.isCreateSubject(row.rawSubject, cell.klass)) ? _c('AddSubject', {
        attrs: {
          "subject": row.rawSubject,
          "calendar": cell.klass,
          "propHours": _vm.lastCreatedHoursBySubjectId[row.rawSubject.id]
        },
        on: {
          "createSubject": _vm.createExistingSubjectInCal,
          "close": _vm.closeIsCreateSubject
        }
      }) : _vm._e()], 1)]
    })], 2)
  })], 2)])])], _vm._v(" "), (_vm.isBulkColorModalOpen) ? _c('modal', {
    on: {
      "close": _vm.closeBulkColorModal
    }
  }, [_c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "bulk-color-modal__header",
    style: ({
      'backgroundColor': _vm.bulkColor || '#A0A5EF'
    })
  }, [_c('h2', [_vm._v(_vm._s(_vm.bulkColorRow ? _vm.bulkColorRow.name : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "bulk-color-modal__body"
  }, [_c('div', {
    staticClass: "bulk-color-modal__section"
  }, [_c('div', {
    staticClass: "d-label-and-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.bulkNameEnabled = !_vm.bulkNameEnabled
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['change_title'] || 'Skift titel'))]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "propOn": _vm.bulkNameEnabled,
      "allowChanges": false
    }
  })], 1), _vm._v(" "), (_vm.bulkNameEnabled) ? _c('div', {
    staticClass: "bulk-color-modal__field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkName),
      expression: "bulkName"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.bulkColorRow ? _vm.bulkColorRow.name : ''
    },
    domProps: {
      "value": (_vm.bulkName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bulkName = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bulk-color-modal__section"
  }, [_c('div', {
    staticClass: "d-label-and-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.bulkHoursEnabled = !_vm.bulkHoursEnabled
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['change_hours'] || 'Opdater klokketimer i skoleåret'))]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "propOn": _vm.bulkHoursEnabled,
      "allowChanges": false
    }
  })], 1), _vm._v(" "), (_vm.bulkHoursEnabled) ? _c('div', {
    staticClass: "bulk-color-modal__field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.bulkHours),
      expression: "bulkHours",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "do-input",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01",
      "placeholder": _vm.bulkColorRow && _vm.bulkColorRow.rawSubject ? String(_vm.bulkColorRow.rawSubject.hours || 0) : ''
    },
    domProps: {
      "value": (_vm.bulkHours)
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bulkHours = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bulk-color-modal__section"
  }, [_c('div', {
    staticClass: "d-label-and-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.bulkSubjectTypeEnabled = !_vm.bulkSubjectTypeEnabled
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['change_subject_type'] || 'Skift briktype'))]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "propOn": _vm.bulkSubjectTypeEnabled,
      "allowChanges": false
    }
  })], 1), _vm._v(" "), (_vm.bulkSubjectTypeEnabled) ? _c('div', {
    staticClass: "bulk-color-modal__field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkSubjectType),
      expression: "bulkSubjectType"
    }],
    staticClass: "d-input__select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bulkSubjectType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--")]), _vm._v(" "), _vm._l((_vm.bulkSubjectTypeOptions), function(t) {
    return _c('option', {
      key: t.value,
      domProps: {
        "value": t.value
      }
    }, [_vm._v(_vm._s(t.name))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bulk-color-modal__section"
  }, [_c('div', {
    staticClass: "d-label-and-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.bulkColorEnabled = !_vm.bulkColorEnabled
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['change_color'] || 'Skift farve'))]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "propOn": _vm.bulkColorEnabled,
      "allowChanges": false
    }
  })], 1), _vm._v(" "), (_vm.bulkColorEnabled) ? _c('div', {
    staticClass: "bulk-color-modal__field"
  }, [_c('ColorPicker', {
    attrs: {
      "initialColor": _vm.bulkColor
    },
    on: {
      "changedColor": _vm.setBulkColor
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bulk-color-modal__section"
  }, [_c('div', {
    staticClass: "d-label-and-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.bulkRoomEnabled = !_vm.bulkRoomEnabled
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_c('span', {
    staticClass: "icon-location"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['change_room'] || 'Skift lokale'))]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "propOn": _vm.bulkRoomEnabled,
      "allowChanges": false
    }
  })], 1), _vm._v(" "), (_vm.bulkRoomEnabled) ? _c('div', {
    staticClass: "bulk-color-modal__field"
  }, [_c('DSelectCalendarIds', {
    attrs: {
      "itemType": "ROOM",
      "isMultiple": false,
      "preSelectedItems": []
    },
    on: {
      "update": _vm.setBulkRoom
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bulk-color-modal__actions"
  }, [_c('button', {
    staticClass: "do-bttn",
    attrs: {
      "disabled": _vm.bulkColorLoading
    },
    on: {
      "click": _vm.closeBulkColorModal
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel'] || 'Annullér'))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.bulkColorLoading
    },
    attrs: {
      "disabled": _vm.bulkColorLoading || (!_vm.bulkColorEnabled && !_vm.bulkRoomEnabled && !_vm.bulkNameEnabled && !_vm.bulkHoursEnabled && !_vm.bulkSubjectTypeEnabled && !_vm.bulkPreparationEnabled)
    },
    on: {
      "click": _vm.saveBulkColor
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['update'] || 'Opdatér'))])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.isKlassRoomModalOpen) ? _c('modal', {
    on: {
      "close": _vm.closeKlassRoomModal
    }
  }, [_c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "bulk-color-modal__header",
    style: ({
      'backgroundColor': '#468AD7'
    })
  }, [_c('h2', [_vm._v(_vm._s(_vm.klassRoomName))])]), _vm._v(" "), _c('div', {
    staticClass: "bulk-color-modal__body"
  }, [_c('div', {
    staticClass: "bulk-color-modal__section"
  }, [_c('label', {
    staticClass: "bulk-color-modal__label"
  }, [_c('span', {
    staticClass: "icon-location"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_room_to_klass']))]), _vm._v(" "), _c('DSelectCalendarIds', {
    attrs: {
      "itemType": "ROOM",
      "isMultiple": false,
      "preSelectedItems": _vm.klassRoomSelected
    },
    on: {
      "update": _vm.setKlassRoom
    }
  })], 1), _vm._v(" "), (_vm.klassRoomSubjects.length > 0) ? _c('div', {
    staticClass: "bulk-color-modal__section"
  }, [_c('label', {
    staticClass: "bulk-color-modal__label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select_subjects']))]), _vm._v(" "), _c('ul', {
    staticClass: "klass-room-subjects"
  }, _vm._l((_vm.klassRoomSubjects), function(subj) {
    return _c('li', {
      key: subj.id,
      staticClass: "klass-room-subjects__item",
      on: {
        "click": function($event) {
          return _vm.toggleKlassRoomSubject(subj.id)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": !_vm.klassRoomExcluded[subj.id]
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleKlassRoomSubject(subj.id)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "klass-room-subjects__color",
      style: ({
        'backgroundColor': subj.cell.klass.color
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "klass-room-subjects__name"
    }, [_vm._v(_vm._s(subj.name))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bulk-color-modal__actions"
  }, [_c('button', {
    staticClass: "do-bttn",
    attrs: {
      "disabled": _vm.klassRoomLoading
    },
    on: {
      "click": _vm.closeKlassRoomModal
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--loading': _vm.klassRoomLoading
    },
    attrs: {
      "disabled": _vm.klassRoomLoading || _vm.klassRoomSelected.length === 0
    },
    on: {
      "click": _vm.saveKlassRoom
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['update']))])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.isSubjectModal) ? _c('SubjectForm', {
    attrs: {
      "propCalendarId": _vm.createInCalendarId,
      "showModal": _vm.isSubjectModal,
      "editSubject": _vm.editSubject,
      "isActivities": _vm.isActivities
    },
    on: {
      "close": _vm.closeModal,
      "createSubject": _vm.createNewSubject,
      "updateSubject": _vm.updateSubject,
      "deleteSubject": _vm.deleteSubject,
      "saveAndShowTab": _vm.saveAndShowTab
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a690d52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/BulkCreateSubjects.vue
// module id = 1782
// module chunks = 1